module.exports = __webpack_public_path__ + "img/iot-scene-factory.064834e1.png";